import { EmptyState, StateMessage } from "@/ds";
import type { DetailSectionStateViewModel } from "./types-detail-section-state";

/** Seção sem informações no padrão de estado vazio do Hub; os demais cenários, no `StateMessage` do DS. */
export function DetailSectionStateView({
  emptyContent,
  emptyTestId,
  mensagem,
}: DetailSectionStateViewModel) {
  if (!mensagem) {
    return (
      <EmptyState.Root size="sm" testId={emptyTestId}>
        <EmptyState.Illustration name="sem-dados" />
        <EmptyState.Title>{emptyContent.title}</EmptyState.Title>
        <EmptyState.Description>{emptyContent.description}</EmptyState.Description>
      </EmptyState.Root>
    );
  }

  return <StateMessage {...mensagem} />;
}
